module.exports = __webpack_public_path__ + "static/media/no_content.e56a05a0.svg";